import React from "react";
import { Link } from 'react-router-dom';
import { sendAnalyticsEvent } from "../../../utils/SendAnalyticsEvent";

function CTAButton(params) {
    const sendEvent = () => {
        if (!params?.text || params?.text === "Get Started") {
            const eventProperties = {
                getStartedSectionContext: params?.context,
                checkSubSectionName: params?.category
            };
            sendAnalyticsEvent("getStartedClick", eventProperties, "Purchase Journey", "Discover page");
        } else if (params.eventName) {
            sendAnalyticsEvent(params.eventName, {}, "Purchase Journey", "Discover page");
        }
    };
    return (
        <Link to={params.link ? params.link : "/select-plan"} onClick={() => sendEvent()} className="cta-button" target={params.target ? params.target : "_self"}>{params.text ? params.text : "Get Started"}</Link>
    );
}

export default CTAButton;